import { Outlet } from "react-router-dom";
import { useState, useEffect } from "react";
import useRefreshToken from "../hooks/useRefreshToken";
import useAuth from "../hooks/useAuth";

const PersistLogin = () => {
    const [isLoading, setIsLoading] = useState(true);
    const refresh = useRefreshToken();
    const { auth, setAuth } = useAuth();

    useEffect(() => {
        let isMounted = true; // Cleanup flag

        const verifyRefreshToken = async () => {
            console.log('Attempting token refresh');
            try {
                const newAccessToken = await refresh();

                if (isMounted) {
                    console.log('Token refresh successful');
                    setAuth(prev => ({
                        ...prev,
                        isAuthenticated: true,
                        accessToken: newAccessToken
                    }));
                }
            } catch (err) {
                console.error("Refresh failed - clearing auth:", err);
                if (isMounted) {
                    setAuth({
                        isAuthenticated: false,
                        user: null,
                        user_id: null,
                        group_id: null,
                        group_name: null,
                        permissions: [],
                        accessToken: null
                    });
                }
            } finally {
                if (isMounted) setIsLoading(false);
            }
        };

        // Only attempt refresh if no existing valid token
        if (!auth?.accessToken || !auth?.isAuthenticated) {
            verifyRefreshToken();
        } else {
            console.log('Using existing valid token');
            setIsLoading(false);
        }

        return () => {
            isMounted = false; // Cleanup on unmount
        };
    }, []); // Empty array = runs once on mount

    console.log(`PersistLogin render - Loading: ${isLoading}, Authenticated: ${auth?.isAuthenticated}`);

    return isLoading ? (
        <div className="full-page-loading">
            {/*            <p>Loading session...</p>  */}
        </div>
    ) : (
        <Outlet />
    );
};

export default PersistLogin;